<!-- PUZZLE-->
<div class="d-flex flex-wrap" id="puzzle_wrapper" #puzzle>
    <div class="puzzle-items"
         *ngFor="let item of items"
         [style.backgroundImage]="'url('+ item.backgroundImage +')'"
         [style.backgroundSize]="puzzleWrapperWidth + 'px ' + (puzzleWrapperWidth *  imageHeight) / imageWidth  + 'px'"
         [style.backgroundPosition]="item.backgroundPosition"
         [style.width]="item?.width + 'px'"
         [style.height]="item?.height + 'px'"
         [style.opacity]="item.opacity"
         [class.dotted-border]="!interaction.completed.onComplete"
         mwlDroppable (drop)="onDrop($event, item)">
    </div>
</div>
<div class="d-flex flex-wrap mt-3" id="puzzle_random_wrapper" *ngIf="!interaction.completed.onComplete">
    <div class="puzzle-random-items"
         *ngFor="let item of randomizedItems"
         [style.backgroundImage]="'url('+ image +')'"
         [style.backgroundSize]="puzzleWrapperWidth + 'px ' + (puzzleWrapperWidth *  imageHeight) / imageWidth  + 'px'"
         [style.backgroundPosition]="item.backgroundPosition"
         [style.width]="item?.width + 'px'"
         [style.height]="item?.height + 'px'"
         [style.opacity]="item.opacity"
         [style.display]="item.display"
         [class.dotted-border]="!interaction.completed.onComplete"
         mwlDraggable
         [dropData]="item.id"
    >
    </div>
</div>
